module.exports = __webpack_public_path__ + "static/hkgrotesk-bold-255703bd20b057795375701dd5f94cc3.woff";